module.exports = __webpack_public_path__ + "static/img/banner_text.867afd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/financialCompetition/banner_text.png
// module id = u8d8
// module chunks = 86